import React, { useEffect, useState } from 'react'
import Layout from '../../components/global/Layout'
import Hero from '../../components/guide/Hero/Hero'
import SectionIntroParent from '../../components/guide/sections/SectionIntro/SectionIntroParent'
import SectionJelajahi from '../../components/guide/sections/SectionJelajahi/SectionJelajahi'
import SectionStats from '../../components/home/sections/SectionStats/SectionStats'
import { BASE_URL } from '../../utils/config'

function useStatisticBook() {
    const [statisticBook, setStatisticBook] = useState({});
    const [loadingStatisticBook, setLoadingStatisticBook] = useState(true);
    const [errorStatisticBook, setErrorStatisticBook] = useState(null);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await fetch(`${BASE_URL}/api/statistic/getSummary`, {
                    cache: 'no-store',
                    headers: {
                        'Cache-Control': 'no-cache',
                        Pragma: 'no-cache',
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const responseData = await response.json();
                setStatisticBook(responseData);
                setLoadingStatisticBook(false);
            } catch (error) {
                setErrorStatisticBook(error);
                setLoadingStatisticBook(false);
            }
        }

        fetchData();
    }, []);
  
    return { statisticBook, errorStatisticBook, loadingStatisticBook };
}

const ForParent = () => {
    const { statisticBook } = useStatisticBook();

    const content = {
        subtitle: 'BUKU UNTUK ORANG TUA',
        title: 'Bantu tingkatkan proses belajar anak',
        image: '/assets/image/guide/untuk ortu.png',
        vector: '/assets/image/guide/vectorForParent.png',
        description: 'Dengan akses gratis ke semua buku pelajaran resmi Kemendikdasmen dari jenjang pendidikan PAUD sampai SMA'
    }

    return (
        <Layout guide>
            <Hero content={content} role="parent" />
            <SectionIntroParent />
            <SectionJelajahi />
            <SectionStats data={statisticBook} guide />
        </Layout>
    )
}

export default ForParent